import { render } from "./news-list.vue?vue&type=template&id=5297e030&scoped=true"
import script from "./news-list.vue?vue&type=script&lang=js"
export * from "./news-list.vue?vue&type=script&lang=js"

import "./news-list.vue?vue&type=style&index=0&id=5297e030&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5297e030"]])

export default __exports__